import { Plaque } from "./Plaque";
import { shortWallet, useLastRound } from "./useLeaderboard";

/**
 * Summary of the most recently settled KotH round. Renders winner, runner-up,
 * final pot, and touch count. Refetches whenever the indexer fires a bust
 * with `last-round` in the surfaces array.
 */

interface LastRoundPlaqueProps {
  position: [number, number, number];
  rotation?: [number, number, number];
  gameId?: string;
}

const LAMPORTS_PER_SOL = 1_000_000_000;

function lamportsToSol(lamports: number | null): string {
  if (lamports === null) return "—";
  return (lamports / LAMPORTS_PER_SOL).toFixed(4);
}

export function LastRoundPlaque({
  position,
  rotation,
  gameId = "koth",
}: LastRoundPlaqueProps): JSX.Element {
  const { data, error } = useLastRound({ gameId });

  let lines: string[];
  if (error && !data) {
    lines = ["(offline)"];
  } else if (!data) {
    lines = ["(no settled round)"];
  } else {
    lines = [
      `Round #${data.roundId}`,
      `👑 ${shortWallet(data.finalKing)}`,
      `2nd: ${shortWallet(data.finalRunnerUp)}`,
      `Pot: ${lamportsToSol(data.finalPotLamports)} SOL`,
      `Touches: ${data.touchCount}`,
    ];
  }

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={3.4}
      height={2.6}
      backerColor="#1f1f2a"
      title="LAST ROUND"
      titleColor="#f4d36a"
      titleSize={0.22}
      lines={lines}
      bodyColor="#e8e8ef"
      bodySize={0.2}
      align="left"
    />
  );
}
